<template>
    <div style="width:100%;heigh:100%;" id="quality">
        <template v-if="showPage == 0">
            <el-card class="table_searchbar">
                <el-row>
                    <el-col :span="5">
                        <div class="" @keydown.enter="btnSearch()">
                            <span class="title">返工单号：</span>
                            <el-input size="small" style="max-width:180px;" v-model="searchForm.reworkCode" placeholder="返工单号"></el-input>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="" @keydown.enter="btnSearch()">
                            <span class="title">原工单号：</span>
                            <el-input size="small" style="max-width:180px;" v-model="searchForm.productionBatchCode" placeholder="原工单号"></el-input>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="" @keydown.enter="btnSearch()">
                            <span class="title" style="width:98px;margin-left: -28px;">物料编码：</span>
                            <el-input size="small" style="max-width:180px;" v-model="searchForm.materialCode" placeholder="物料编码"></el-input>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="" @keydown.enter="btnSearch()">
                            <span class="title" style="width:98px;margin-left: -28px;">物料名称：</span>
                            <el-input size="small" style="max-width:180px;" v-model="searchForm.materialName" placeholder="物料名称"></el-input>
                        </div>
                    </el-col>
                    
                </el-row>
                <el-row>
                    <el-col :span="5">
                        <div class="" @keydown.enter="btnSearch()">
                            <span class="title">工序：</span>
                            <el-input size="small" style="max-width:180px;" v-model="searchForm.procedureName" placeholder="工序"></el-input>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="">
                            <span class="title">返工类型：</span>
                            <el-select clearable size="small" style="max-width:180px;" v-model="searchForm.reworkType" filterable placeholder="返工类型">
                                <el-option v-for="item in typeOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="">
                            <span class="title">返工状态：</span>
                            <el-select clearable size="small" filterable style="max-width:180px;"  v-model="searchForm.reworkStatus" placeholder="返工状态">
                                <el-option v-for="item in statusOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="">
                            <span class="title">创建时间：</span>
                            <el-date-picker value-format="yyyy-MM-dd" v-model="searchForm.gmtCreate" type="date" format="yyyy-MM-dd" placeholder="创建时间" style="display:inline-block;width:180px"></el-date-picker>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div style="text-align:right">
                            <el-button size="mini" icon="el-icon-search" type="primary" @click="btnSearch()">查询</el-button>
                            <el-button size="mini" icon="el-icon-refresh" @click='clearSearch'>重置</el-button>
                        </div>
                    </el-col>
                </el-row>
            </el-card>
            <el-card class="table-card">
                <el-table :data="tableData" style="width: 100%" class="deviceTable " >
                    <el-table-column prop="reworkCode" label="返工单号" min-width="80" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="productionBatchCode" label="原工单号" min-width="80" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="materialCode" label="物料编码" min-width="100" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="materialName" label="物料名称" min-width="100" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="specification" label="物料规格" min-width="100" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="procedureName" label="来源工序" min-width="80" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="reworkType" label="返工类型" :formatter="parseType" min-width="60" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="routeName" label="返工路径"  min-width="60" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="reworkAmount"  label="返工数量" :min-width="W?60:80" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="reworkStatus" label="返工状态" :formatter='parseStatus' min-width="60" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="gmtCreate" label="创建时间"  :formatter='$commonUtil.changeToDate' min-width="80" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="gmtModified" label="更新时间"  :formatter='$commonUtil.changeToDate' min-width="80" show-overflow-tooltip></el-table-column>
                    <el-table-column label="操作" fixed="right" width="180">
                        <template slot-scope="scope">
                            <el-button type="text" @click="showViewDialog(scope.row)" size="small">查看</el-button>
                            <el-button v-if="permission.btn_reworkPlan_confirmReworkPlan&&scope.row.reworkStatus==0" type="text" @click="showEditDialog(scope.row)" size="small">编辑</el-button>
                            <el-button type="text" v-if="scope.row.reworkStatus==1&&permission.btn_reworkPlan_arrayReworkPlan" @click="arrayTask(scope.row,1)"  size="small">下发</el-button>
                            <el-button type="text" v-if="scope.row.reworkStatus==2&&permission.btn_reworkPlan_cancelReworkPlan" @click="arrayTask(scope.row,2)"  size="small">取消下发</el-button>
                            <el-button type="text" v-if="scope.row.reworkStatus>=2" @click="printOrder(scope.row)" size="small">打印</el-button>
                            <el-button v-if="(scope.row.reworkStatus==4)&&permission.btn_reworkPlan_deleteReworkPlan" type="text" @click="deleteTask(scope.row)" size="small">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="page" v-if="tableData.length > 0">
                    <div class="total_page"><span> 共{{tableTotalPage}}条 10条/页</span></div>
                    <div style="margin-top:10px;text-align:right; margin-bottom:20px;">
                        <el-pagination background layout="prev, pager, next" :total="tableTotalPage" @current-change="pageChange" :current-page="tableCurrentPage"> </el-pagination>
                    </div>
                </div>
            </el-card>
            <!-- 编辑开始 -->
            <el-dialog title="编辑返工任务" @close="cancelEditDialog" :visible.sync="editDialogVisible" :width="W?'52%':'68%'" center :close-on-click-modal="false">
                <el-form :model="addForm" :rules="rules" ref="editForm" style="width:100%;" class="add_form">
                    <el-row :gutter="20">
                        <el-col :span="6">
                            <div class="">
                                <span class="title">返工单号：</span>
                                <span class="value">{{addForm.reworkCode}}</span>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="">
                                <span class="title">工单号：</span>
                                <span class="value">{{addForm.productionBatchCode}}</span>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="">
                                <span class="title" >工序：</span>
                                <span class="value"  style="">{{addForm.procedureName}}</span>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="">
                                <span class="title" >返工状态：</span>
                                <span class="value" >{{addForm.reworkStatus}}</span>
                            </div>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20" style="height: 56px;line-height: 56px;margin-bottom:0px">
                        <el-col :span="6">
                            <div class="">
                                <span class="title">物料编码：</span>
                                <span class="value">{{addForm.materialCode}}</span>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="">
                                <span class="title">物料名称：</span>
                                <span class="value">{{addForm.materialName}}</span>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="">
                                <span class="title">返工数量：</span>
                                <span class="value">{{addForm.reworkAmount}}</span>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="">
                                <span class="title">返工路径：</span>
                                <el-form-item class="value" style='display: inline-block;' prop="technologyId">
                                    <el-select filterable size="small" style="max-width:140px;" v-model="addForm.technologyId" placeholder="返工路径">
                                        <el-option v-for="item in retecList" :key="item.id" :label="item.routeName" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20" style="height: 56px;line-height: 56px;margin-bottom:20px">
                        
                        <el-col :span="12" >
                            <div class="">
                                <span class="title">物料规格：</span>
                                <span class="value">{{addForm.specification}}</span>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="">
                                <span class="title" style="width: 98px;margin-left: -28px;">工序任务进度：</span>
                                <span class="value">{{addForm.processRatio}}</span>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="">
                                <span class="title">返工类型：</span>
                                <el-form-item class="value" style='display: inline-block;' prop="reworkType">
                                    <el-select filterable size="small" style="max-width:140px;" v-model="addForm.reworkType" placeholder="返工类型">
                                        <el-option v-for="item in typeOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="6">
                            <div class="">
                                <span class="title">返工原因：</span>
                                <span class="value">{{addForm.reworkReason}}</span>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
                <span slot="footer" style="margin-top:-10px">
                    <el-button type="primary" @click="submitEditDialog">确 认</el-button>
                    <el-button @click="cancelEditDialog">取 消</el-button>
                </span>
            </el-dialog>
            <!-- 编辑结束 -->

            <!-- 查看开始 -->
            <el-dialog title="查看返工任务" @close="cancelViewDialog" :visible.sync="viewDialogVisible" :width="W?'48%':'68%'" center :close-on-click-modal="false">
                <el-form :model="addForm" :rules="rules" ref="editForm" style="width:100%;" class="add_form view_form">
                    <el-row :gutter="20">
                        <el-col :span="6">
                            <div class="">
                                <span class="title">返工单号：</span>
                                <span class="value">{{addForm.reworkCode}}</span>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="">
                                <span class="title">工单号：</span>
                                <span class="value">{{addForm.productionBatchCode}}</span>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="">
                                <span class="title" >工序：</span>
                                <span class="value"  style="">{{addForm.procedureName}}</span>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="">
                                <span class="title" >返工状态：</span>
                                <span class="value" >{{addForm.reworkStatus}}</span>
                            </div>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20" >
                        <el-col :span="6">
                            <div class="">
                                <span class="title">物料编码：</span>
                                <span class="value">{{addForm.materialCode}}</span>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="">
                                <span class="title">物料名称：</span>
                                <span class="value">{{addForm.materialName}}</span>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="">
                                <span class="title">返工数量：</span>
                                <span class="value">{{addForm.reworkAmount}}</span>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="">
                                <span class="title">返工路径：</span>
                                <span class="value">{{addForm.routeName}}</span>
                            </div>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20" >
                        
                        <el-col :span="12" >
                            <div class="">
                                <span class="title">物料规格：</span>
                                <span class="value">{{addForm.specification}}</span>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="">
                                <span class="title" style="width: 98px;margin-left: -28px;">工序任务进度：</span>
                                <span class="value">{{addForm.processRatio}}</span>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="">
                                <span class="title">返工类型：</span>
                                <span class="value">{{addForm.reworkType}}</span>
                            </div>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="6">
                            <div class="">
                                <span class="title">返工原因：</span>
                                <span class="value">{{addForm.reworkReason}}</span>
                            </div>
                        </el-col>
                    </el-row>
                    
                    <el-row >
                        <el-row>
                            <el-table class="quality-list" :data="addForm.planDetailTableList" style="width: 100%;margin-bottom:-10px; overflow-y: auto;max-height:460px" tooltip-effect="dark">
                                <el-table-column label="序号" type="index" width="50"></el-table-column>
                                <el-table-column prop="procedureName" label="工序名称" min-width="100" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="actualStartTime" label="实际开始时间" :formatter='$commonUtil.changeToDate' min-width="110" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="actualEndTime" label="实际结束实际" :formatter='$commonUtil.changeToDate' min-width="100" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="workerName" label="执行者" min-width="100" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="deviceCode" label="设备" min-width="100" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="qualifiedProcessCount" label="合格数量" min-width="80" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="spoiledProcessCount" label="报废数量" min-width="80" show-overflow-tooltip></el-table-column>
                            </el-table>
                        </el-row>
                    </el-row>
                </el-form>
                <span slot="footer" style="margin-top:-10px">
                    <!-- <el-button type="primary" @click="cancelViewDialog">确 定</el-button> -->
                    <el-button   @click="cancelViewDialog" >取 消</el-button>
                </span>
            </el-dialog>
            <!-- 查看结束 -->

          
        </template>

        
    </div>
</template>

<script>

export default {
    name: 'ProductionRework',
    data() {
        let vm = this
        return {
            fristLoad: false,
            showPage: 0,
            typeOption: [
                { label: '生产返工', value: 0 },
                { label: '完成返工', value: 1 },
               
            ],
           tableData:[],
            statusOption: [  
                { label: '待确认', value: 0 },
                { label: '已确认', value: 1 },
                { label: '已下发', value: 2 },
                { label: '返工中', value: 3 },
                { label: '返工完成', value: 4 },
            ],
            W: false,
            btnPressType: 0,//按钮类型： 0-默认 1-查询 2-重置 3-分页
            searchFormTemp: '',//临时搜索数据
            searchForm: {
                reworkCode: '',
                procedureName: '',
                productionBatchCode: '',
                materialCode: '',
                materialName: '',
                reworkStatus: null,
                reworkType: null,
                gmtCreate: null,
            },
            tableTotalPage:1,
            tableCurrentPage:1,
            editDialogVisible:false,
            viewDialogVisible:false,
            addForm: {
                qualifiedCount: null,
                userId: null,
                deviceId: null,
                planDetailTableList: [],
            },
            retecList:[],
            rules: {
                reworkType: [
                    { required: true, message: '请选择返工路径', trigger: 'blur' }
                ],
                technologyId: [
                    { required: true, message: '请选择返工类型', trigger: 'blur' }
                ],
                
            },
            permission: JSON.parse(localStorage.getItem("permission")),
        }
        
    },
    mounted: function () {
        this.initTable();
        let w = document.documentElement.clientWidth || document.body.clientWidth;
        w >= 1900 ? this.W = true : this.W = false
        window.onresize = () => {
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            w >= 1900 ? this.W = true : this.W = false
        }
    },
    computed: {
        span() {
            return this.W ? 8 : 8
        }
    },

    filters: {
        paseRate(ev) {

            ev = Number(ev)
            if ((ev || ev == 0)) {
                ev.toFixed()
                return ev + '%'
            }

        }
    },
    deactivated: function () {
        console.log("deactivated");
    },
    methods: {

        deleteTask(rowData) {
            this.$confirm('此操作将会删除返工任务, 删除后不可撤销，是否继续?', '提示', {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$RequestUtil.post({
                    url: '/api/reworkPlan/deleteReworkPlan',
                    type: 'sync',
                    params: {
                        id: rowData.id
                    },
                    success: (res) => {
                        if (res.code != -1) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.search(1);
                        } else {
                            this.$message.error(res.msg || res.message)
                        }
                    }
                })
            })
        },

        parseStatus(rowData) {
            let num = Number(rowData.reworkStatus)
            let str = ''
            return (this.statusOption.find(item => item.value == num)||{}).label
        },

        parseType(rowData){
            return (this.typeOption.find(item => item.value == rowData.reworkType)||{}).label
        },

        cancelEditDialog() {
            this.$refs['editForm'].resetFields()
            this.editDialogVisible = false
            this.addForm = {}
        },

        showEditDialog: async function (rowData) {
            let data = await this.loadDetailById(rowData.id)
            let includeId = data.defaultTechnologyId
            if(data.technologyId){
                includeId = data.technologyId
            }else{
                rowData.technologyId = data.defaultTechnologyId
            }
            
            this.addForm = commonUtils.cloneObj(rowData)
            this.addForm.reworkStatus = this.parseStatus(rowData)
            
            this.loadRetecList(includeId,null,data.materialId, data.workShopId)
            this.addForm.processRatio = data.processRatio + '%'
            this.addForm.reworkReason = data.reworkReason
            this.editDialogVisible = true;
        },
        
        async showViewDialog(rowData){
            let data = await this.loadDetailById(rowData.id)
            this.addForm = data
            this.addForm.reworkStatus = this.parseStatus(data)
            this.addForm.reworkType = this.parseType(data)
            this.addForm.processRatio = data.processRatio + '%'
            this.viewDialogVisible = true
        },

        async printOrder(rowData){
            let data = await this.loadDetailById(rowData.id)
            data.reworkType = this.parseType(data)
            localStorage.setItem('printAllOrderData', JSON.stringify([data]))
            localStorage.setItem('modelType', 8)
            let routeUrl = this.$router.resolve({ path: "/printAllOrder" });
            window.open(routeUrl.href, '_blank');
        },

        cancelViewDialog() {
            this.viewDialogVisible = false
            this.addForm = {}
        },

        loadRetecList(includeId,routeName,materialId, workShopId){
            this.$RequestUtil.get({
                url: '/api/select/listReworkTec',
                type:'sync',
                params: {includeId,routeName,materialId, workShopId},
                success: (res) => {
                    if (res.code == 0) {
                        this.retecList = res.data
                    } else {
                        this.$message.error(res.msg || res.message)
                    }
                }
            })
        },

        async loadDetailById(id){
            let { data,msg,code} = await this.$RequestUtil.getAsync({url: '/api/reworkPlan/getReworkPlan',type:'sync',params: {id},})
            return data
        },

        submitEditDialog() {
            this.$refs['editForm'].validate((valid) => {
                if (valid || valid == undefined) {
                    this.$RequestUtil.post({
                        url: '/api/reworkPlan/confirmReworkPlan',
                        type: 'sync',
                        params:{
                            reworkType:this.addForm.reworkType,
                            id:this.addForm.id,
                            technologyId:this.addForm.technologyId
                        },
                        success: (res) => {
                            if (res.code == 0) {
                                this.$message.success('编辑成功')
                                this.editDialogVisible = false
                                this.initTable();
                                this.cancelEditDialog()
                            } else {
                                this.$message.error(res.message);
                            }
                        },
                    })
                }
            })
        },
        
        arrayTask(rowData,type){
            let url = '/api/reworkPlan/cancelReworkPlan'
            let title = '取消下发成功'
            if(type==1){
                url = '/api/reworkPlan/arrayReworkPlan'
                title = '下发成功'
            }
            this.$RequestUtil.post({
                url,
                type: 'sync',
                params:{
                    id:rowData.id
                },
                success: (res) => {
                    if (res.code == 0) {
                        this.$message.success(title)
                        this.initTable();
                    } else {
                        this.$message.error(res.message);
                    }
                },
            })
        },
        
        
        btnSearch: function () {
            this.tableCurrentPage = 1;
            this.btnPressType = 1
            this.search();
        },

        clearSearch() {
            let form = this.searchForm;
            this.btnPressType = 2;
            form.reworkCode = ''
            form.procedureName = ''
            form.productionBatchCode = ''
            form.reworkStatus = null
            form.reworkType = null
            form.gmtCreate = null,
            form.materialName = ''
            form.materialCode = ''
           
        },

        search: function () {
            let temp;
            switch (this.btnPressType) {
                case 1:
                    temp = commonUtils.cloneObj(this.searchForm);
                    this.searchFormTemp = commonUtils.cloneObj(temp);
                    break;
                case 0:
                    temp = {
                        reworkCode: '',
                        procedureName: '',
                        productionBatchCode: '',
                        materialCode: '',
                        materialName: '',
                        reworkStatus: null,
                        reworkType: null,
                        gmtCreate: null,
                    };
                    break;
                case 2:
                    temp = this.searchFormTemp;
                    break;
                case 3:
                    temp = this.searchFormTemp;
                    break;
            }
            this.$RequestUtil.get({
                url: '/api/reworkPlan/listReworkPlan',
                type: 'sync',
                params: {
                    pageNum: this.tableCurrentPage,
                    pageSize: 10,
                    reworkCode: temp.reworkCode,
                    procedureName: temp.procedureName,
                    productionBatchCode: temp.productionBatchCode,
                    reworkStatus: temp.reworkStatus,
                    reworkType: temp.reworkType,
                    gmtCreate:temp.gmtCreate,
                    materialName: temp.materialName,
                    materialCode: temp.materialCode
                },
                success: (res) => {
                    if (res.msg == this.$Global.RESPONSE.SUCCESS) {
                        this.tableData = res.data;
                        this.tableTotalPage = res.totalPages;
                        if (res.totalPages == 0 && this.fristLoad) {
                            this.$message.warning('查询不到符合条件的数据');
                        }
                        this.fristLoad = true
                        this.loadOrderList()
                    } else {
                        this.$message.error(res.message || res.msg)
                    }

                }
            });
        },

        pageChange: function (targetPage) {
            this.tableCurrentPage = targetPage;
            this.btnPressType = 3;
            this.search();
        },

        initTable: function () {
            this.search();
        },

       
        parseDate: function (rowData) {
            if (rowData.gmtCreate != null) {
                let dateString = commonUtils.timestampToDate(rowData.gmtCreate, true);
                return dateString;
            }
        },
        
    }
}
</script>

<style scoped>
/* .posBtn{
    margin-left: 50px;
    margin-top: 50px;
    margin-bottom: 50px;
} */
.dialog-footer {
    margin-top: -20px;
}

.delete {
    width: 18px;
    height: 19px;
    background-image: url("../../../static/img/del.png");
    cursor: pointer;
    background-repeat: no-repeat;
}

.delete:hover {
    background-image: url("../../../static/img/del-hover.png");
    background-repeat: no-repeat;
}

.table_searchbar .title11 {
    color: #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
    width: 70px;
    text-align: right;
    display: inline-block;
}

.add_form .title {
    color: #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
    display: inline-block;
    text-align: right;
    width: 70px;
}
.view_form .title {
    text-align: left;
    width: auto;
}
.add_form .value {
    display: inline-block;
}

.el-row {
    margin-bottom: 20px;

    & :last-child {
        margin-bottom: 0;
    }
}



.import_upload {
    display: inline;
}

.page {
    display: flex;
    justify-content: flex-end;
}

@media screen and (max-width: 1380px) {
    .page {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 30px;
    }
}

.total_page {
    margin-top: 20px;
    margin-right: 26px;
    color: #606266;
    font-size: 14px;
}
</style>
<style>
#quality .el-form-item__error {
    width: 180px;
}

#quality .el-form-item--mini.el-form-item,
#quality .el-form-item--small.el-form-item {
    margin-top: 8px;
    margin-bottom: 13px;
}

.table_searchbar .el-button--mini,
.el-button--mini.is-round {
    padding: 7px 10px;
}

.el-textarea .el-input__count {
    line-height: 12px;
}

.quality-list::before {
    background-color: #fff !important;
}
.y_material_table {
    overflow: inherit !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Rework/ReworkTask.vue